module.exports = new __parcel__URL__("icons8-youtube.0c955bd4.svg").toString();